import React, { Component } from 'react';

export default class ErrorPage extends Component {
  render() {
    return (
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <h1>台灣圖書館電子書搜尋</h1>
        <strike>
          <div style={{ fontSize: '14px' }}>
            <p>感謝大家這幾年來對本網站的支持與愛護！</p>
            <p>由於伺服器服務商的政策變動，網站需額外支出營運成本；</p>
            <p>
              再加上個人時間有限，實在難以持續維護，因此我決定結束網站的營運。
            </p>
            <p>若您有任何問題或需進一步聯繫，歡迎透過以下方式與我聯絡：</p>
            <p>
              聯絡信箱：
              <a href="mailto:michaelintoronto2020@gmail.com">
                michaelintoronto2020@gmail.com
              </a>
            </p>
            <p>衷心感謝大家一路以來的支持，祝您平安順心！</p>
          </div>
        </strike>

        <div
          style={{ textAlign: 'center', fontSize: '18px', marginTop: '20px' }}
        >
          感謝您使用「台灣圖書館電子書搜尋」！原本我計劃關閉網站，原因如上。
          <br />
          <br />
          但這段時間收到許多使用者來信，表示這個工具對他們非常有幫助，
          <br />
          <br />
          這也讓我覺得運作了幾年的網站就這樣關掉似乎有點可惜。
          <br />
          <br />
          因此我決定想辦法重新啟動服務。預計會在六月底前完成。
          <br />
          <br />
          如果您有餘力且願意支持，到時歡迎&nbsp;
          <a
            href="https://www.buymeacoffee.com/twlibraryebook/membership"
            target="_blank"
          >
            加入會員
          </a>
          &nbsp; (每個月65塊台幣)支持開發者。
          <br />
          <br />
          您的支持與鼓勵讓我能夠有資源繼續維護網站運作，謝謝！
        </div>
      </div>
    );
  }
}
